import { render } from "./GridConfigDialog.vue?vue&type=template&id=c78c8436&scoped=true"
import script from "./GridConfigDialog.vue?vue&type=script&lang=js"
export * from "./GridConfigDialog.vue?vue&type=script&lang=js"

import "./GridConfigDialog.vue?vue&type=style&index=0&id=c78c8436&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78c8436"]])

export default __exports__